import {PercentageOutlined} from '@ant-design/icons';
import logoTypeSvg from 'assets/images/promotion-center/new/logoType.svg';
import {numberFormat} from 'utils/Helper';

import PromotionStockBadge from '../../../components/common/PromotionStockBadge/PromotionStockBadge';

type DiscountViewProduct = {
  id?: number | string;
  title?: string;
  share?: number;
  price?: number;
  discounted_price?: number;
  discount_share_type?: string;
  stock?: number;
  stock_label?: string;
  image_url?: string;
  product_title?: string;
};

type DiscountViewProductItemProps = {
  item: DiscountViewProduct;
};

const DiscountViewProductItem: React.FC<DiscountViewProductItemProps> = ({item}) => {
  return (
    <div className="flex items-center gap-2.5 bg-white">
      <div className="ms-2 me-4 flex size-12.5 shrink-0 items-start justify-center overflow-hidden rounded-lg">
        <img
          className="size-12.5 rounded-lg object-cover"
          src={item.image_url ? item.image_url : logoTypeSvg}
          alt={item.product_title}
        />
      </div>
      <div className="flex flex-1 items-center justify-between border-b border-gray-02 py-3">
        <div className="flex flex-col gap-2">
          <span className="text-body-sm-emphasis text-neutral-fg">{item.title}</span>
          {item.discount_share_type === 'brand' ? (
            <div className="flex items-center gap-2.5">
              <span className="rounded bg-gray-02 px-1.5 text-body-xs-emphasis">
                %{item.share} تخفیف فروشگاه
              </span>
              <span className="inline-flex items-center gap-1 rounded bg-gray-02 px-1.5 text-body-xs-emphasis">
                <PercentageOutlined aria-hidden />
                تخفیف برند
              </span>
            </div>
          ) : null}
          <div className="flex items-center gap-1.5">
            {item.discount_share_type !== 'brand' ? (
              <span className="rounded bg-gray-02 px-1.5 text-body-xs-emphasis">{item.share}%</span>
            ) : null}
            {item.price ? (
              <span className="text-body-xs text-gray-06 line-through">{numberFormat(item.price)}</span>
            ) : null}
            {item.discounted_price ? (
              <span className="text-body-sm">{numberFormat(item.discounted_price)}</span>
            ) : null}
            <span className="text-body-xs">تومان</span>
          </div>
        </div>
        <div className="min-w-19">
          <PromotionStockBadge stock={item.stock} state={item.stock_label} />
        </div>
      </div>
    </div>
  );
};

export default DiscountViewProductItem;
